import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { CartProvider } from "@/contexts/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Lookbook from "@/pages/Lookbook";
import Community from "@/pages/Community";
import Journal from "@/pages/Journal";
import Contact from "@/pages/Contact";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App font-body bg-maly-cream text-maly-navy">
      <BrowserRouter>
        <LanguageProvider>
          <CartProvider>
            <ScrollToTop />
            <Navbar />
            <CartDrawer />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:slug" element={<ProductDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/lookbook" element={<Lookbook />} />
                <Route path="/community" element={<Community />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
              </Routes>
            </main>
            <Footer />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#1E2F4D",
                  color: "#F8F5F0",
                  border: "none",
                  borderRadius: 0,
                  fontFamily: "Jost, sans-serif",
                  fontSize: 13,
                  letterSpacing: "0.05em",
                },
              }}
            />
          </CartProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
